<!-- Loads one of the core/layouts depending on route parent -->
<router-outlet />
